import SocialMedia from './SocialMedia'

export default SocialMedia
// eslint-disable-next-line import/export
export * from './SocialMedia'
